/**
 * Normalize plan code for display and styling (matches billing API and UI).
 */
export function normalizePlanCode(planCode: string | null | undefined): string {
  const raw = String(planCode || '').trim().toLowerCase()
  if (raw === 'max') return 'ultra'
  if (raw === 'pro_plus' || raw === 'pro+' || raw === 'pro-plus' || raw === 'pro plus') return 'pro_plus'
  return raw || 'free'
}

/**
 * Tailwind classes for plan badges. Use consistently in billing page, Adjust plan modal, and workspace switcher.
 * Pro = blue, Pro+ = green, Ultra = magenta.
 */
export function planBadgeClass(planCode: string | null | undefined): string {
  const normalized = normalizePlanCode(planCode)
  if (normalized === 'pro') return 'bg-blue-500/20 text-blue-600 dark:text-blue-400'
  if (normalized === 'pro_plus') return 'bg-emerald-500/20 text-emerald-600 dark:text-emerald-400'
  if (normalized === 'ultra') return 'bg-fuchsia-500/20 text-fuchsia-600 dark:text-fuchsia-400'
  return 'bg-gray-500/20 text-gray-700 dark:text-gray-300'
}

/**
 * Display label for plan code.
 */
export function formatPlanLabel(planCode: string | null | undefined): string {
  const normalized = normalizePlanCode(planCode)
  if (normalized === 'free') return 'Free'
  if (normalized === 'pro') return 'Pro'
  if (normalized === 'pro_plus') return 'Pro+'
  if (normalized === 'ultra') return 'Ultra'
  return normalized ? normalized[0].toUpperCase() + normalized.slice(1) : 'Unknown'
}
